<template>
  <div class="section">
    <div class="section-title">
      Start a New Game
    </div>
    <div class="section-body">
      <div class="section-row">
        <div>
          You'll host a game and get a room code.
        </div>
        <SpinnerButton
          class="button"
          :isProcessing="startGameButtonClicked"
          @click="createGame"
        >
          Start
        </SpinnerButton>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import SpinnerButton from '@/components/utilComponents/SpinnerButton';

export default Vue.extend({
  name: 'StartTeamComponent',
  components: {
    SpinnerButton
  },
  data: () => ({
    startGameButtonClicked: false
  }),
  computed: {
    auth0UserId: function () {
      return this.$auth.user.sub.replace(/\|/g, '_');
    }
  },
  methods: {
    createGame() {
      this.startGameButtonClicked = true;
      this.$router.push({
        name: 'gamesetup',
        params: {
          wasRedirectedFromGameEntrance: true
        }
      });
    }
  }
})
</script>

<style scoped lang="scss">
.section {
  width: 100%;
  min-height: min-content;
  color: $dark-brown;
  padding: 0.4em 0.8em;
  margin-bottom: 1em;
}

.section-title {
  font-size: 1.4em;
  font-weight: bold;
  padding: 0.4em 0.8em;
}

.section-body {
  background-color: white;
  border: 0.1em solid $dark-sand;
  border-radius: 0.6em;
  padding: 0.8em 1.2em;
}

.section-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.roomcode-input {
  flex: 1;
  font-size: 1em;
  padding: 0.4em 0.8em;
  margin-right: 0.8em;
  font-family: inherit;
}

.button {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 2.2em;
  width: 6em;
  color: $natural-white;
  background-color: $brand-teal;
  text-align: center;
  border-radius: 0.2em;
  box-shadow: 0 1px 1px 1px $light-gray;
  user-select: none;
  cursor: pointer;
  &:hover {
    background-color: $light-teal;
  }
}

.button-content {
  flex: 1;
}

.error-text {
  flex: 1;
  padding: 0.8em 1.2em;
  margin-bottom: 0.6em;
  background-color: $baby-blue;
  border-radius: 0.3em;
}
</style>
